"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleFederationHelper = void 0;
var main_1 = require("../main");
var environment_helper_1 = require("./environment.helper");
var EAGER_DEPS = {
    COMMON_LIBS: "@tpd-web-common-libs/nodejs-library",
    ANGULAR_LIBS: "@tpd-web-angular-libs/angular-library",
    REACT_LIBS: "@tpd-web-react-libs/nodejs-library",
    REACT: "react",
    REACT_DOM: "react-dom",
    EMOTION_STYLED: "@emotion/styled",
    EMOTION_REACT: "@emotion/react",
    EMOTION_CACHE: "@emotion/cache",
    ANGULAR_CORE: "@angular/core",
    ANGULAR_COMMON: "@angular/common",
    ANGULAR_COMMON_HTTP: "@angular/common/http",
    ANGULAR_COMPILER: "@angular/compiler",
    ANGULAR_PLATFORM_SERVER: "@angular/platform-server",
};
function buildReactSharedModuleFederationDeps(PACKAGE, eagerDeps, getPackageVersion) {
    return function () {
        return Object.keys(PACKAGE.dependencies).reduce(function (acc, depKey) {
            var _a, _b;
            if (eagerDeps.includes(depKey)) {
                var version = getPackageVersion(depKey);
                if (depKey === exports.ModuleFederationHelper.EAGER_DEPS.COMMON_LIBS ||
                    depKey === exports.ModuleFederationHelper.EAGER_DEPS.REACT_LIBS) {
                    return __assign(__assign({}, acc), (_a = {}, _a[depKey] = {
                        eager: false,
                        singleton: true,
                        // strictVersion: true,
                        requiredVersion: version, // TODO - need to test if it works
                    }, _a));
                }
                else {
                    return __assign(__assign({}, acc), (_b = {}, _b[depKey] = {
                        eager: true,
                        singleton: true,
                        // strictVersion: true,
                        requiredVersion: version, // TODO - need to test if it works
                    }, _b));
                }
                // return {
                //   ...acc,
                //   [depKey]: {
                //     eager: true,
                //     requiredVersion: version, // TODO - need to test if it works
                //     singleton: true,
                //   },
                // };
            }
            else {
                return acc;
            }
        }, PACKAGE.dependencies);
    };
}
function buildAngularSharedModuleFederationDeps(PACKAGE, eagerDeps, getPackageVersion) {
    return function (share, sharedMappings) {
        var deps = Object.keys(PACKAGE.dependencies).reduce(function (acc, depKey) {
            var _a, _b;
            if (eagerDeps.includes(depKey)) {
                if (depKey ===
                    exports.ModuleFederationHelper.EAGER_DEPS.ANGULAR_LIBS ||
                    depKey ===
                        exports.ModuleFederationHelper.EAGER_DEPS.COMMON_LIBS) {
                    return __assign(__assign({}, acc), (_a = {}, _a[depKey] = {
                        eager: false,
                        singleton: true,
                        // strictVersion: true,
                        requiredVersion: getPackageVersion(depKey), // TODO - need to test if it works
                    }, _a));
                }
                else {
                    return __assign(__assign({}, acc), (_b = {}, _b[depKey] = {
                        eager: true,
                        singleton: true,
                        // strictVersion: true,
                        requiredVersion: getPackageVersion(depKey), // TODO - need to test if it works
                    }, _b));
                }
            }
            else {
                return acc;
            }
        }, {});
        return share(__assign(__assign({}, deps), sharedMappings.getDescriptors()));
    };
}
function buildRemoteModuleFederationConfigs(__mfeName__, shared, ENV_CONFIG) {
    var remotesEntries = {};
    if (__mfeName__ === main_1.MFE_NAMES.tpdRemotesImporter ||
        __mfeName__ === main_1.MFE_NAMES.tpdLoginHeaderContainer) {
        remotesEntries = ENV_CONFIG.REMOTES_ENTRIES;
        remotesEntries = Object.entries(remotesEntries).reduce(function (acc, el) {
            var _a;
            var __mfeName__ = el[0], mapEntries = el[1];
            if (!main_1.MFE_SETTINGS[__mfeName__].skipImportingInCMS) {
                return __assign(__assign({}, acc), (_a = {}, _a[__mfeName__] = mapEntries, _a));
            }
            else {
                return acc;
            }
        }, {});
    }
    return {
        clientConfig: exports.ModuleFederationHelper.buildRemoteModuleFederationConfig(__mfeName__, remotesEntries, shared, false),
        serverConfig: exports.ModuleFederationHelper.buildRemoteModuleFederationConfig(__mfeName__, remotesEntries, shared, true),
    };
}
function buildRemoteModuleFederationConfig(__mfeName__, remotesEntries, shared, isServer) {
    return {
        name: __mfeName__,
        library: { type: "var", name: __mfeName__ },
        filename: "remoteEntry.js",
        exposes: {
            "./bootstrap": "./src/bootstrap" + (isServer ? "Server" : "Client") + ".ts",
        },
        remotes: exports.ModuleFederationHelper.getRemotesFrom(remotesEntries, isServer),
        shared: shared,
    };
}
function getRemotesFrom(remotesEntries, isServer) {
    return Object.entries(remotesEntries).reduce(function (acc, _a) {
        var _b;
        var __mfeName__ = _a[0], uri = _a[1];
        return __assign(__assign({}, acc), (_b = {}, _b[__mfeName__] = isServer
            ? exports.ModuleFederationHelper.buildServerSideRemote(__mfeName__, uri["server"])
            : "".concat(__mfeName__, "@").concat(uri["client"]), _b));
    }, {});
}
function buildServerSideRemote(__mfeName__, remoteUrlEndpoint, shared) {
    if (shared === void 0) { shared = {}; }
    return "".concat(__mfeName__, "@").concat(remoteUrlEndpoint);
}
function buildClientSideRemote(__mfeName__, remoteUrlEndpoint, shared) {
    if (shared === void 0) { shared = {}; }
    return "promise new Promise((resolveImportFunc) => {\n    function evalCode(scriptContent, moduleName) {\n      const scriptContentParsed = '(()=>{ \\n' + scriptContent + '\\n  try{ return ' + moduleName + '}catch(e) { return null; }; \\n})()';\n      return eval.call(this, scriptContentParsed);\n    }\n\n    function rpcLoad(url, cb) {\n      return fetch(url).then(res => res.text());\n    }\n\n    function rpcPerform(moduleName = \"\", originalScriptUrl = \"\") {\n      let scriptUrl = originalScriptUrl;\n      if (!window.location.origin.match(\"http://localhost\")) {\n        const [a, b, c, ...slugs] = scriptUrl.split(\"/\");\n        const path = slugs.join(\"/\");\n        scriptUrl = window.location.origin + \"/\" + path;\n      }\n      return rpcLoad(scriptUrl).then(scriptContent => {\n        const remote = evalCode(scriptContent, moduleName);\n        if (!!remote) {\n          if (typeof remote === \"object\" && \"init\" in remote && \"get\" in remote) {\n            return remote;\n          } else {\n            throw new Error(\"remote library \" + moduleName + \" is not an object!\");\n          }\n        } else {\n          throw new Error(\"remote library \" + moduleName + \" is not found at \" + scriptUrl);\n        }\n      });\n    }\n\n    function rpcProcess(remote) {\n      return {\n        get: (request) => {\n          return remote.get(request)\n        },\n        init: (arg) => {\n          try {\n            return remote.init(arg)\n          } catch(e){\n            console.error('remote container already initialized');\n            return null;\n          }\n        }\n      }\n    }\n\n    window[\"__remotes__\"] = window[\"__remotes__\"] || {};\n    window[\"__remotes__\"][\"".concat(__mfeName__, "\"] = rpcPerform(\"").concat(__mfeName__, "\", \"").concat(remoteUrlEndpoint, "\")\n      .then(remote => rpcProcess(remote))\n      .catch(err => {\n        console.error('======== TPD_REMOTES_IMPORTER - MODULE FEDERATION ERROR =============');\n        console.error('").concat(__mfeName__, " not loaded');\n        console.error('=====================');\n        return {\n          get: () => null,\n          init: () => null\n        };\n      })\n\n    window[\"__remotes__\"][\"").concat(__mfeName__, "\"].then(resolveImportFunc);\n  })\n  ");
}
function initWebpackLoadRemoteClientSide(envConfig) {
    var _this = this;
    return function (__mfeName__, module) {
        if (module === void 0) { module = "./bootstrap"; }
        return function () { return __awaiter(_this, void 0, void 0, function () {
            var remoteScriptUrl, container, factory, Module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!environment_helper_1.EnvironmentHelper.isClientSide()) return [3 /*break*/, 5];
                        remoteScriptUrl = envConfig.REMOTES_ENTRIES[__mfeName__].client;
                        if (!envConfig.ENV_NAME.match("local")) {
                            remoteScriptUrl = new URL(remoteScriptUrl).pathname;
                        }
                        return [4 /*yield*/, exports.ModuleFederationHelper.loadRemoteClientScript(remoteScriptUrl)];
                    case 1:
                        _a.sent();
                        // Initializes the shared scope. Fills it with known provided modules from this build and all remotes
                        return [4 /*yield*/, __webpack_init_sharing__("default")];
                    case 2:
                        // Initializes the shared scope. Fills it with known provided modules from this build and all remotes
                        _a.sent();
                        container = window[__mfeName__];
                        // Initialize the container, it may provide shared modules
                        return [4 /*yield*/, container.init(__webpack_share_scopes__.default)];
                    case 3:
                        // Initialize the container, it may provide shared modules
                        _a.sent();
                        return [4 /*yield*/, container.get(module)];
                    case 4:
                        factory = _a.sent();
                        Module = factory();
                        return [2 /*return*/, Module];
                    case 5: throw new Error("[initWebpackLoadRemoteClientSide] Can't load the remote Server Side");
                }
            });
        }); };
    };
}
function loadRemoteClientScript(url) {
    return new Promise(function (resolve, reject) {
        if (!environment_helper_1.EnvironmentHelper.isClientSide()) {
            reject("[loadRemoteClientScript] Error: Can't load the remote Server Side");
        }
        else if (!url) {
            reject("[loadRemoteClientScript] Error: url is not defined ".concat(url));
        }
        else {
            var elementScript = document.querySelector("head script[src='".concat(url, "']"));
            if (elementScript) {
                // it's already loaded
                return resolve(true);
            }
            else {
                var element = document.createElement("script");
                element.src = url;
                element.type = "text/javascript";
                element.async = true;
                element.onload = function () {
                    resolve(true);
                };
                element.onerror = function (error) {
                    reject("[loadRemoteClientScript] Error: Loading Remote script\n ".concat(error));
                };
                document.head.appendChild(element);
            }
        }
    });
}
exports.ModuleFederationHelper = {
    EAGER_DEPS: EAGER_DEPS,
    NEXT_EAGER_DEPS: [
        EAGER_DEPS.COMMON_LIBS,
        EAGER_DEPS.EMOTION_STYLED,
        EAGER_DEPS.EMOTION_REACT,
        EAGER_DEPS.EMOTION_CACHE,
        EAGER_DEPS.REACT,
        EAGER_DEPS.REACT_DOM
    ],
    BASE_REACT_EAGER_DEPS: [
        EAGER_DEPS.COMMON_LIBS,
        EAGER_DEPS.REACT_LIBS,
        EAGER_DEPS.REACT,
        EAGER_DEPS.REACT_DOM,
        EAGER_DEPS.EMOTION_STYLED,
        EAGER_DEPS.EMOTION_REACT,
        EAGER_DEPS.EMOTION_CACHE,
    ],
    BASE_ANGULAR_EAGER_DEPS: [
        EAGER_DEPS.COMMON_LIBS,
        EAGER_DEPS.ANGULAR_LIBS,
        EAGER_DEPS.ANGULAR_CORE,
        EAGER_DEPS.ANGULAR_COMMON,
        EAGER_DEPS.ANGULAR_COMMON_HTTP,
        EAGER_DEPS.ANGULAR_COMPILER,
        EAGER_DEPS.ANGULAR_PLATFORM_SERVER,
    ],
    buildReactSharedModuleFederationDeps: buildReactSharedModuleFederationDeps,
    buildAngularSharedModuleFederationDeps: buildAngularSharedModuleFederationDeps,
    buildRemoteModuleFederationConfigs: buildRemoteModuleFederationConfigs,
    buildRemoteModuleFederationConfig: buildRemoteModuleFederationConfig,
    getRemotesFrom: getRemotesFrom,
    buildServerSideRemote: buildServerSideRemote,
    buildClientSideRemote: buildClientSideRemote,
    initWebpackLoadRemoteClientSide: initWebpackLoadRemoteClientSide,
    loadRemoteClientScript: loadRemoteClientScript,
};
